const single_sign_on = {
    forbidden_domains: '不允許使用公共電子郵件域名。',
    duplicated_domains: '存在重複的域名。',
    /** UNTRANSLATED */
    invalid_domain_format: 'Invalid domain format.',
    /** UNTRANSLATED */
    duplicate_connector_name: 'Connector name already exists. Please choose a different name.',
};
export default Object.freeze(single_sign_on);
